import React from 'react';
import { getLocationsForPoint } from '_utils/geo-matching';

const GeoArea = ({ coordinates, locations }) => {
    const lat = coordinates?.latitude;
    const lon = coordinates?.longitude;

    const matched = getLocationsForPoint(locations, lat, lon);

    if (matched.length === 0) return <span>—</span>;
    return <span>{matched.join(', ')}</span>;
};

export default GeoArea;
